import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Box, Text } from '@maui/elements'
import { Exploit } from './Exploit'
import withFreemium from '../common/Freemium/WithFreemium'
import { Term, Definition } from '../common/Details'
import ListExpander from '../common/ListExpander'

const ExploitsWithFreemium = withFreemium({ prop: 'list', layout: 'fullCenter' })(
  ({ list, expandHandler, expanded }) => {
    if (!list || !list.length) {
      return <Text marginBottom="16px">No data available</Text>
    }

    return (
      <>
        <Box
          as="ul"
          padding="0"
          margin="0"
          listStyleType="none"
        >
          {list.slice(0, expanded ? list.length - 1 : 3).map(
            (item, i) => <Exploit key={i} {...item} />)
          }
        </Box>
        {list.length > 3 &&
          <ListExpander
            type="Exploits"
            total={list.length}
            expandHandler={expandHandler}
            expanded={expanded}
          />
        }
      </>
    )
  }
)
export const ExploitsDetail = (props) => {
  const [showAll, setShowAll] = useState(false)
  const list = props.list || []

  return (
    <>
      <Term>Exploits</Term>
      <Definition>
        <ExploitsWithFreemium
          list={list}
          expandHandler={() => setShowAll(!showAll)}
          expanded={showAll}
        />
      </Definition>
    </>
  )
}

ExploitsDetail.propTypes = {
  list: PropTypes.array
}

export default ExploitsDetail
